/* eslint-disable camelcase */
import { Alert } from '@pmi/dsm-react';
import CustomAlert from '../CustomAlert';
import { AlertMessage } from '../models';
import { IconMap } from '../customIcons';
import styles from '../alertGroup.module.scss';

function FormatMessage({ message }: { message: AlertMessage }) {
  if (message.subCategory === 'agreement_product_fully_consumed') {
    return `Warning: ${message.data.product_name} on Agreement ${message.data.dealid} has been fully consumed and is unavailable for further enrollments.`;
  }

  if (message.subCategory === 'agreement_product_quantity_below_x') {
    return `Warning: ${message.data.product_name} on Agreement ${
      message.data.dealid
    } only has ${message.data.quantity_remaining} ${
      message.data.quantity_remaining === 1 ? 'enrollment' : 'enrollments'
    } remaining.`;
  }

  return null;
}

function ProductQuantityAlert({
  message,
  onAlertClose,
}: {
  message: AlertMessage;
  onAlertClose: (alert: AlertMessage) => void;
}) {
  return (
    <CustomAlert
      message={message}
      onAlertClose={onAlertClose}
      textContent={FormatMessage({ message })}
    />
  );
}

export default function ProductQuantityAlertContainer({
  messages,
  onAlertClose,
  showLowQuantityAlert,
  setShowLowQuantityAlert,
}: {
  messages: AlertMessage[];
  onAlertClose: (alert: AlertMessage) => void;
  showLowQuantityAlert: boolean;
  setShowLowQuantityAlert: (flag: boolean) => void;
}) {
  if (showLowQuantityAlert) {
    return (
      <div
        className={`col-12 ${styles.alertContainer} ${styles.lowQuantityAlertContainer}`}
      >
        <Alert
          icon={IconMap.warning}
          variant="warning"
          show={showLowQuantityAlert}
          alertText="Warning: Multiple products are running low in available quantity."
          actionableLinkText="Click here to view"
          onActionableLinkClick={() => {
            setShowLowQuantityAlert(false);
          }}
        />
      </div>
    );
  }

  return (
    <>
      {messages.map((message) => (
        <div className={`col-12 ${styles.alertContainer}`} key={message.id}>
          <ProductQuantityAlert message={message} onAlertClose={onAlertClose} />
        </div>
      ))}
    </>
  );
}
